import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { assertNever } from 'owa-assert';
import { action } from 'satcheljs/lib/legacy';
import {
    getMailboxJunkEmailConfiguration,
    saveMailboxJunkEmailConfiguration,
} from 'owa-junkmail-configuration';

const saveSpamOption = action('saveSpamOption')(async function saveSpamOption(
    scenarioId: SpamScenarioId
): Promise<void> {
    const mailboxJunkEmailConfiguration = await getMailboxJunkEmailConfiguration();
    const { spamList } = getSpamScenarioStore(scenarioId);

    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            mailboxJunkEmailConfiguration.BlockedSendersAndDomains = spamList;
            break;
        case SpamScenarioId.SafeSendersAndDomains:
            mailboxJunkEmailConfiguration.TrustedSendersAndDomains = spamList;
            break;
        case SpamScenarioId.SafeMailingLists:
            mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains = spamList;
            break;
        case SpamScenarioId.AllowedDynamicEmailSenders:
            // List of allowed dynamic email senders is stored in OWS'
            // This is taken care of in saveDynamicEmailOptions.ts
            break;
        default:
            assertNever(scenarioId);
    }
    await saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration);
});

export default saveSpamOption;
